module.exports = __webpack_public_path__ + "img/success-icon.a196a4a7.png";